import { render } from "./FactorValuesCreating.vue?vue&type=template&id=6a7dcbd4&scoped=true&ts=true"
import script from "./FactorValuesCreating.vue?vue&type=script&lang=ts"
export * from "./FactorValuesCreating.vue?vue&type=script&lang=ts"

import "./FactorValuesCreating.vue?vue&type=style&index=0&id=6a7dcbd4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7dcbd4"]])

export default __exports__